/**
 * @generated SignedSource<<d38858fc85ec57d86ad992a3bf7759e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBreadcrumbs_info$data = {
  readonly name: string;
  readonly platform: string;
  readonly " $fragmentType": "AppBreadcrumbs_info";
};
export type AppBreadcrumbs_info$key = {
  readonly " $data"?: AppBreadcrumbs_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppBreadcrumbs_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppBreadcrumbs_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "d9f0731e595f9e3f45137e158481b9e2";

export default node;
